import { ServiceHandler } from '../../../utils/api.utils';
import type { Agent, AgentAccessEntry, StartersResponse, Tool } from '../types';

export const getAgents = ServiceHandler<unknown, { agents: Agent[] }>({
  url: '/api/chat-agent/v1/agents',
});

export const getAgent = ServiceHandler<unknown, Agent>({
  url: '/api/chat-agent/v1/agents/:agentId',
});

export const getAgentStarters = ServiceHandler<unknown, StartersResponse>({
  url: '/api/chat-agent/v1/agents/:agentId/starters',
});

export const getAgentTools = ServiceHandler<unknown, { tools: Tool[] }>({
  url: '/api/chat-agent/v1/agents/:agentId/tools',
});

export const createAgent = ServiceHandler<Partial<Agent>, Agent>({
  url: '/api/chat-agent/v1/agents',
  method: 'POST',
});

export const updateAgent = ServiceHandler<Partial<Agent>, Agent>({
  url: '/api/chat-agent/v1/agents/:agentId',
  method: 'PUT',
});

export const deleteAgent = ServiceHandler<unknown, void>({
  url: '/api/chat-agent/v1/agents/:agentId',
  method: 'DELETE',
});

export const toggleAgentFavorite = ServiceHandler<unknown, void>({
  url: '/api/chat-agent/v1/agents/:agentId/favorite',
  method: 'POST',
});

export const publishAgent = ServiceHandler<void, Agent>({
  url: '/api/chat-agent/v1/agents/:agentId/publish',
  method: 'POST',
});

export const duplicateAgent = ServiceHandler<void, Agent>({
  url: '/api/chat-agent/v1/agents/:agentId/duplicate',
  method: 'POST',
});

export const getAgentVersions = ServiceHandler<unknown, { versions: Agent[] }>({
  url: '/api/chat-agent/v1/agents/:agentId/versions',
});

export const activateAgentVersion = ServiceHandler<void, Agent>({
  url: '/api/chat-agent/v1/agents/:agentId/versions/:version/activate',
  method: 'POST',
});

export const getAgentAccess = ServiceHandler<
  unknown,
  { access: AgentAccessEntry[] }
>({
  url: '/api/chat-agent/v1/agents/:agentId/access',
});

export const grantAgentAccess = ServiceHandler<
  { userId: string; userName: string; userEmail: string },
  AgentAccessEntry
>({
  url: '/api/chat-agent/v1/agents/:agentId/access',
  method: 'POST',
});

export const revokeAgentAccess = ServiceHandler<unknown, { revoked: boolean }>({
  url: '/api/chat-agent/v1/agents/:agentId/access/:accessId',
  method: 'DELETE',
});
